
import { VacationCardSkeleton } from "../VacationCardSkeleton";

export const DealsLoadingState = () => {
  return (
    <>
      <div className="text-center py-4">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-600 mx-auto"></div>
        <p className="mt-2 text-gray-600">Deals laden...</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {Array.from({ length: 9 }).map((_, index) => (
          <VacationCardSkeleton key={`skeleton-${index}`} />
        ))}
      </div>
    </>
  );
};
